import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class AamsDataConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getLastGameRoundEndpoint(): string {
		return this.configService.get((x) => x.core.wallet.endpoints!.lastGameRound, "v2/it/wallet/lastgameround");
	}

	getTransactionsEndpoint(): string {
		return this.configService.get((x) => x.core.wallet.endpoints!.transactions, "v2/it/wallet/transactions");
	}

	getSessionsEndpoint(): string {
		return this.configService.get((x) => x.core.wallet.endpoints!.sessions, "v2/it/wallet/sessions/");
	}
}
